/**
 * Cosmosbarber_Theme - front-end script (the static site's custom.js trimmed to what the theme uses).
 * Compiled to assets/js/main.min.js by the gulpfile in the WordPress root.
 * Depends on jQuery (WordPress core), Swiper 4 and Magnific Popup (assets/js/vendor).
 */
(function ($) {
    'use strict';

    var Barber = {
        init: function () {
            this.preLoader();
            this.navMenu();
            this.focusText();
            this.topButton();
            this.salBanner();
            this.aboutImg();
            this.saloonTestimonial();
            this.popupGallery();
        },

        /* Preloader */
        preLoader: function () {
            $(window).on('load', function () {
                $('.preloader-wrapper').removeClass('preloader-active');
                setTimeout(function () {
                    $('.preloader-open').addClass('loaded');
                }, 100);
            });
            // safety net: never leave the preloader up if "load" already fired
            setTimeout(function () {
                $('.preloader-wrapper').removeClass('preloader-active').addClass('loaded');
            }, 4000);
        },

        /* Mobile menu (off-canvas) */
        navMenu: function () {
            if (window.innerWidth > 991) {
                return;
            }
            $('.main-menu-wrapper > ul li.has-submenu > a').on('click', function (e) {
                e.preventDefault();
                $(this).parent().find('ul.sub-menu').first().slideToggle();
                $(this).parent().toggleClass('open');
            });
            $('.main-menu-wrapper > ul').on('click', function (e) {
                e.stopPropagation();
            });
            $('.menu-btn').on('click', function (e) {
                e.stopPropagation();
                $('.main-menu-wrapper, .menu-btn-wrap').toggleClass('open');
            });
            $('body').on('click', function () {
                $('.main-menu-wrapper, .menu-btn-wrap').removeClass('open');
            });
        },

        /* Hide the placeholder while a field has focus */
        focusText: function () {
            var place = '';
            $('input, textarea').on('focus', function () {
                place = $(this).attr('placeholder');
                $(this).attr('placeholder', '');
            }).on('blur', function () {
                $(this).attr('placeholder', place);
            });
        },

        /* Go to top button */
        topButton: function () {
            var scrollTop = $('#scroll');
            $(window).on('scroll', function () {
                scrollTop.toggleClass('active', $(this).scrollTop() >= 500);
            });
            scrollTop.on('click', function () {
                $('html, body').animate({ scrollTop: 0 }, 1200);
                return false;
            });
        },

        /* Home banner slider */
        salBanner: function () {
            if (!$('.sal-banner-slider').length) {
                return;
            }
            new Swiper('.swiper-container.sal-banner-slider', {
                autoHeight: false,
                loop: $('.sal-banner-slider .swiper-slide').length > 1,
                spaceBetween: 0,
                centeredSlides: false,
                speed: 1000,
                autoplay: { delay: 5000 },
                keyboard: { enabled: true },
                pagination: { el: '.pagination', clickable: true }
            });
        },

        /* Home about images slider */
        aboutImg: function () {
            if (!$('.swiper-container.aboutImg').length) {
                return;
            }
            new Swiper('.swiper-container.aboutImg', {
                autoHeight: false,
                slidesPerView: 1,
                loop: $('.aboutImg .swiper-slide').length > 1,
                spaceBetween: 0,
                centeredSlides: false,
                speed: 1000,
                autoplay: { delay: 3000 },
                navigation: { nextEl: '.NextImg', prevEl: '.PrevImg' }
            });
        },

        /* Testimonials slider */
        saloonTestimonial: function () {
            if (!$('.swiper-container.saloonTestimonial').length) {
                return;
            }
            var count = $('.saloonTestimonial .swiper-slide').length;
            new Swiper('.swiper-container.saloonTestimonial', {
                autoHeight: false,
                loop: count > 2,
                spaceBetween: 30,
                slidesPerView: 2, // Swiper 4 breakpoints are max-width based
                centeredSlides: false,
                speed: 1000,
                autoplay: { delay: 5000 },
                pagination: { el: '.testimonialBullets', clickable: true },
                navigation: { nextEl: '.testimonialNext', prevEl: '.testimonialPrev' },
                breakpoints: {
                    991: { slidesPerView: 1 }
                }
            });
        },

        /* Gallery lightbox */
        popupGallery: function () {
            if (!$.fn.magnificPopup) {
                return;
            }
            $('.popup-gallery1').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1]
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function (item) {
                        return item.el.attr('title') + '<small></small>';
                    }
                }
            });
        }
    };

    $(function () {
        Barber.init();
    });
})(jQuery);
